import React from 'react';

// Filet de securite de rendu.
//
// Sans lui, la moindre exception levee pendant un rendu demonte tout l'arbre
// React : l'utilisateur se retrouve devant une page blanche, sans message, et
// le diagnostic impose d'ouvrir la console. On affiche desormais l'erreur et de
// quoi repartir.
export default class Bouclier extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erreur: null };
  }

  static getDerivedStateFromError(erreur) {
    return { erreur };
  }

  componentDidCatch(erreur, infos) {
    // Trace conservee pour la console : c'est la seule pile complete disponible.
    console.error('Erreur de rendu :', erreur, infos?.componentStack);
  }

  render() {
    if (!this.state.erreur) return this.props.children;

    return (
      <div style={s.page}>
        <div style={s.boite}>
          <div style={s.titre}>Une erreur est survenue</div>
          <div style={s.texte}>
            L&apos;affichage de cette page a echoue. Le detail ci-dessous aide a identifier la cause.
          </div>
          <pre style={s.detail}>{String(this.state.erreur?.message || this.state.erreur)}</pre>
          <div style={s.actions}>
            <button type="button" style={s.btnPrincipal} onClick={() => window.location.reload()}>
              Recharger la page
            </button>
            <button
              type="button"
              style={s.btnSecondaire}
              onClick={() => { window.location.href = '/'; }}
            >
              Retour a l&apos;accueil
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const s = {
  page: {
    minHeight: '100vh', background: '#F0F2F5', display: 'flex', alignItems: 'center',
    justifyContent: 'center', padding: 20, fontFamily: 'Inter, system-ui, sans-serif',
  },
  boite: {
    background: '#fff', borderRadius: 14, padding: 26, maxWidth: 460, width: '100%',
    boxShadow: '0 10px 40px rgba(0,0,0,0.12)',
  },
  titre: { fontSize: 17, fontWeight: 800, color: '#0D1B2A', marginBottom: 8 },
  texte: { fontSize: 13, color: '#666', lineHeight: 1.5, marginBottom: 14 },
  detail: {
    background: '#FDEDEC', color: '#96281B', borderRadius: 8, padding: '10px 12px',
    fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word', margin: 0, marginBottom: 16,
  },
  actions: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  btnPrincipal: {
    flex: 1, minWidth: 150, minHeight: 44, padding: '11px 16px', borderRadius: 10, border: 'none',
    background: '#C0392B', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer',
    fontFamily: 'inherit',
  },
  btnSecondaire: {
    flex: 1, minWidth: 150, minHeight: 44, padding: '11px 16px', borderRadius: 10,
    border: '1px solid #ddd', background: '#fff', color: '#555', fontSize: 13, cursor: 'pointer',
    fontFamily: 'inherit',
  },
};
